import type { Ref } from 'vue';
import { type ContextType, type ExtendedPartTagType, getCountryUrl } from '@/entities/rubrics';
import { useTourFiltersStore } from '@/entities/filter/store/tour';
import type { CountryTag } from '@/shared/api/experience';
import { DEFAULT_RUBRIC } from '@/widgets/rubricsBlock/tour';

export function useTourCountrySelectedTag(countryTags: Ref<CountryTag[] | undefined>, context: Ref<ContextType>) {
  const filterStore = useTourFiltersStore();

  const selectedTagFromRoute = computed(() => {
    const slug = filterStore.searchState.tag__slugs;

    if (!slug || slug === 'all') {
      return { ...DEFAULT_RUBRIC };
    }

    const foundTag = countryTags.value?.find((tag) => tag.tag_slug === slug);

    if (!foundTag) {
      return { ...DEFAULT_RUBRIC };
    }

    return {
      value: foundTag?.tag_slug || '',
      label: foundTag?.name || '',
      id: foundTag?.id || undefined,
      counter: foundTag?.counters?.[`${context.value}_count`] || undefined,
      url: getCountryUrl(context.value, foundTag?.country_slug || '', foundTag?.tag_slug || 'all'),
      seoUrl: foundTag?.urls?.tours || '',
      is_tours_included: false,
    };
  });

  const selectedValue = ref<ExtendedPartTagType>({ ...DEFAULT_RUBRIC });
  const cachedSelectedValue = ref<ExtendedPartTagType>({ ...DEFAULT_RUBRIC });

  watch(
    () => selectedTagFromRoute.value,
    (newSelectedTagFromRoute) => {
      if (newSelectedTagFromRoute.value) {
        selectedValue.value = newSelectedTagFromRoute;
        cachedSelectedValue.value = newSelectedTagFromRoute;
      }
    },
    { immediate: true },
  );

  return { selectedValue, cachedSelectedValue };
}
